// extracted by mini-css-extract-plugin
module.exports = {"refusal":"Refusal_refusal___d1iO","refusalImg":"Refusal_refusalImg__2bY_1","refusalContent":"Refusal_refusalContent__DI9sn","refusalButtons":"Refusal_refusalButtons__3UFga"};